import { FC, RefObject } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { Header } from "src/components/Header";
import { MobHeader } from "src/components/MobHeader";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { scrollToComponent } from "src/utils/scrollToComponent";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { bannerTrns } from "./trns";

interface Props {
  sectionRef?: RefObject<HTMLElement>;
}

export const Banner: FC<Props> = ({ sectionRef }) => {
  const { t } = useTranslation();

  const onClick = () => scrollToComponent(sectionRef);

  const isMDScreenBreakpoint = useMediaQuery({
    minWidth: SCREEN_BREAKPOINTS.MD,
  });

  return (
    <div
      className={cn("bg-cover bg-center bg-no-repeat", {
        "bg-about-us-banner": isMDScreenBreakpoint,
        "bg-about-us-banner-mobile": !isMDScreenBreakpoint,
      })}
    >
      <Header />
      <MobHeader />

      <div className="container flex flex-col items-center justify-center gap-10 max-w-172 mx-auto py-48 lg:py-80">
        <h1 className="text-purple-base text-20 md:text-40 gl:text-52">
          {t(bannerTrns.title)}
        </h1>

        <p
          className="text-purple-base gl:text-xl text-justify font-thin max-w-172"
          dangerouslySetInnerHTML={{ __html: t(bannerTrns.description) }}
        />

        <Button
          className="md:text-xl font-medium px-5 py-3 w-full sm:w-auto"
          variant={ButtonVariants.PRIMARY}
          onClick={onClick}
        >
          {t(bannerTrns.offerButton)}
        </Button>
      </div>
    </div>
  );
};
